import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'


class MenuTabs extends React.Component {
  render() {
    let content;
    let buttons = [];
    return (
      <div id={this.props.name} className={this.props.style.tabs}>
        {React.Children.map(this.props.children, child => {
          buttons.push({label : child.props.label, name : child.props.name})
          if (child.props.label === this.props.tabState.activeTab) content = child.props.children
        })}

        <TabButtons 
          activeTab={this.props.tabState.activeTab} 
          buttons={buttons} 
          changeTab={this.props.changeHandler} 
          style={this.props.style} 
        />

        <div  
            id="tabContent" 
            className={this.props.style['tab-content']}>        
          {content}
        </div>

      </div>
    );
  }
}

const TabButtons = ({ buttons, changeTab, activeTab,style }) => {

  return (
    <div className={`tab-buttons ${style['tab-buttons']}`}>
      {buttons.map((button,index) => {
        return ( <div   key={button.label} >
         
        <button 
                
                  id={button.label} 
                  className={style['active']} 
                  onClick={() => changeTab(button.label)}><span>
                  <span className={style['menu-name']}> {button.name}</span>
                  </span>
                  <span className={style["arrow-right"]}><FontAwesomeIcon icon={faAngleRight} /></span>
                </button>
               
                </div>)
      })}    
    </div>
  )
}

const MenuTab = props => {
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}

 

export { MenuTabs, MenuTab }

